// extracted by mini-css-extract-plugin
export var aboveInput = "_ly-0";
export var actionButton = "_ly-5";
export var actionButtonContainer = "_ly-1";
export var actionIcon = "_ly-6";
export var aiInfoContainer = "_ly-2";
export var attachmentWrapper = "_ly-7";
export var bold = "_ly-3";
export var checkIcon = "_ly-8";
export var clickingRecipientBar = "_ly-11";
export var commentThreadSwitch = "_ly-a";
export var draftImage = "_ly-b";
export var draftImageContainer = "_ly-c";
export var draftImages = "_ly-e";
export var editButton = "_ly-g";
export var editor = "_ly-f";
export var editorContainer = "_ly-y";
export var editorErrorTooltipWrapper = "_ly-9";
export var headerDivider = "_ly-h";
export var icon = "_ly-i";
export var info = "_ly-j";
export var internal = "_ly-n";
export var internalDivider = "_ly-k";
export var internalMessage = "_ly-l";
export var messageInputCard = "_ly-m";
export var messageInputForm = "_ly-o";
export var messageInputFormInternal = "_ly-p";
export var options = "_ly-q";
export var publicMessageCustomer = "_ly-s";
export var publicMessageMerchant = "_ly-r";
export var removeImageButton = "_ly-d";
export var replyButtons = "_ly-t";
export var showSignatureButton = "_ly-u";
export var spinner = "_ly-v";
export var verticalButtonDivider = "_ly-4";
export var visibilitySelector = "_ly-w";
export var warning = "_ly-x";
export var wrappingText = "_ly-z";
export var writingInternalNoteTopBorder = "_ly-10";